module.exports = __webpack_public_path__ + "img/small-tree.c71ef083.webp";